var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"divide-y divide-gray-200 overflow-y-auto flex-grow scrollbar"},[_vm._l((_vm.items),function(item,index){return _c('li',{key:_vm.getItemKeyFn(item, index)},[_vm._t("default",null,{"item":item,"index":index})],2)}),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }